module.exports = __webpack_public_path__ + "img/side-teeth.eb5e09fb.png";